<template>
  <div>
    <v-container fluid class="lighten-12 container">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="[
            'search',
            'dateRange',
            'guest',
            'waiter',
            'table',
            'place',
             'ordertype',
             
          ]"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    :items="suspendedBills"
                  
                    hide-default-footer
                  >
                    <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="Order" />
                      </div>
                    </template>
               <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="Order" />
                      </div>
                    </template>
                    <template v-slot:item.order_number="{ item }">
                      <CopyTableCell
                        :text="item.order_number"
                      ></CopyTableCell>
                    </template>
                    <template
                      v-slot:item.date="{ item }"
                      v-slot="{ errors }"
                      name="value"
                      rules="numeric"
                      >{{ item.date | formatDate }}</template
                    >
                     <template
                      v-slot:item.balance="{ item }"
                      v-slot="{ errors }"
                      name="value"
                      rules="numeric"
                      >{{ item.total_amount-item.paid_amount }}</template
                    >
                    <template
                      v-slot:item.status="{ item }"
                      v-slot="{ errors }"
                      name="Quantity"
                      rules="numeric"
                    >
                      <v-chip
                        :x-small="true"
                        class="ma-2"
                        label
                        text-color="white"
                        :color="getPurchaseOrderStatusColor(item.status)"
                        dark
                        >{{getPurchaseOrderStatuslable(item.status)}}</v-chip
                      >
                    </template>
                    <!-- Status -->
                   
                    <template v-slot:item.actions="{ item }">
                      <list-menu
                        feature="suspended_bills"
                        :item="item"
                        viewPermission="Purchase Order Show"
                        
                        @refreshList="refreshData"
                      ></list-menu>
                    </template>
                 
                    <template v-slot:footer="{}">
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        :url="'hms/orders/status/partially_paid'"
                        @response="receiveSuspendedBills"
                        :filter="filter"
                        ref="pagination"
                      />
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { required, email, max, numeric } from "vee-validate/dist/rules";
import noData from "@/components/shared/noItem";
import TableFilters from "@/components/base/TableFilters";
// Mixins
// import Suppliers from "@/mixins/Suppliers";

import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import paginationComponent from '../shared/components/pagination.vue'
import { mapGetters } from "vuex";
import { has } from "lodash";

import * as moment from "moment/moment";

extend("numeric", {
  ...numeric,
  message: "input must be numeric",
});
export default {
  // mixins: [Suppliers],
  data: () => ({
    paginationOptions: {},
    purchaseOrderStatus: ["Pending", "Canceled", "Received"],
    messages: [],
    errors: [],
    status: [
      { text: "Active", value: "active" },
      { text: "Archived", value: "archived" },
    ],
    columns: [
      {
        text: "Date",
        value: "date",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
      {
        text: "order no",
        value: "order_number",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
       {
        text: "Guest",
        value: "guest.name",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
        {
        text: "Place",
        value: "place.name",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
       {
        text: "Table",
        value: "table.name",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
       {
        text: "Waiter",
        value: "waiter.name",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
      {
        text: "Total Amount",
        value: "total_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "12.5%",
      },
         {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "12.5%",
      },

      {
        text: "Balance Amount",
        value: "balance",
        show: true,
        align: "left",
        disabled: true,
        width: "12.5%",
      },
      {
        text: "Bill status",
        value: "status",
        show: true,
        align: "center",
        disabled: false,
        width: "12.5%",
      },
      {
        text: "Actions",
        value: "actions",
        show: true,
        disabled: true,
        align: "center",
        width: "12.5%",
      },
    ],
    // For Purchase Order Table Data
    suspendedBills: [],

    //For Filter
    date_range: [],
    filter: {
      invoice_status: "",
      start: "",
      end: "",
      amount: "",
      supplier: "",
      search: "",
      status: "",
    },
    menu: false,
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },
  computed: {
    ...mapGetters(["getInvoiceStatusOptions"]),
    ...mapGetters(["supplier", "GetAllSuppliers"]),
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(" ~ ");
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    getStatusColor(ststus) {
      return status=='paid' ? "green" : "red";
    },

    clearFilter() {
      this.filter = {};
      this.date_range = [];
    },
    receiveSuspendedBills(data) {

      console.log('data',data);
      this.suspendedBills = data;
    },
    dateFormat: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    archivePurchaseOrder(purchaseOrder) {},
    addPurchaseOrder() {
      this.$router.push(`purchase-order/add`);
    },
    getPurchaseOrderStatuslable(status){
       switch (status) {
        case "paid":
          return "paid";
          break;
        case "partially_paid":
          return "Partially Paid";
          break;
        case "cancelled":
          return "Cancelled";
          break;
             case "pending":
          return "Pending";
          break;
               case "receiving":
          return "Receiving";
          break;
            case "completed":
          return "Completed";
          break;
        default:
          break;
      }
    },
     getPurchaseOrderStatusColor(status) {
      
      switch (status) {
        case "paid":
          return "green";
          break;
        case "partially_paid":
          return "orange";
          break;
        case "cancelled":
          return "red";
          break;
            case "pending":
          return "yellow";
          break;
               case "receiving":
          return "Receiving";
          break;
            case "completed":
          return "Completed";
          break;
        default:
          break;
      }
    },
  },

  filters: {
    hasName: function (value) {
      if (has(value, "name")) return value.name;
      else return "-";
    },
  },
};
</script>
